module.exports = __webpack_public_path__ + "img/W.6e870f4c.png";